import $ from "jquery";
import fjGallery from "flickr-justified-gallery";

export default class JustifiedGallery {
    constructor() {
        let galleries = document.querySelectorAll('[data-justifiedGallery]');
        [...galleries].map((item, i) => {
            let rowHeight = $(item).attr('data-justifiedGallery');
            let lastRow = $(item).attr('data-lastRow');
            fjGallery(item, {
                itemSelector: '.g-item',
                gutter: 20,
                rowHeight: rowHeight === '200' ? 300 : rowHeight,
                lastRow: lastRow
            });
        });
    }
}
